import { socialLinks } from "config/config";
import { trackEvent, AnalyticsEvents } from "utils/analytics";

const SocialLinks = () => {
  return (
    <div id="social-links">
      {socialLinks.length > 0 && (
        <div className="space-evenly">
          {socialLinks.map(({ link, icon: Icon }, index) => (
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              key={index}
              className="gridItem"
              onClick={() => {
                trackEvent(AnalyticsEvents.OUTBOUND_CLICK, {
                  url: link,
                  type: "social_link",
                });
              }}
            >
              <Icon width={24} height={24} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default SocialLinks;
